import { render, staticRenderFns } from "./AddDispatchNote.vue?vue&type=template&id=686d3e76&scoped=true&"
import script from "./AddDispatchNote.vue?vue&type=script&lang=js&"
export * from "./AddDispatchNote.vue?vue&type=script&lang=js&"
import style0 from "./AddDispatchNote.vue?vue&type=style&index=0&id=686d3e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d3e76",
  null
  
)

export default component.exports